import Vue from 'vue';
import $ from 'jquery';
import ListPage from "@/components/list-page/list-page.vue";

if($('#vivapark-houselist-app').length>0){
    new Vue({
        render(h) {
            return h(ListPage, { props: {} });
        },
        methods: {}
    }).$mount('#vivapark-houselist-app');
}





